export const dialogProps = {
  bodyClassName: 'package-details-dialog',
  contentClassName: 'package-details-dialog-content',
  actionsContainerClassName: 'package-details-dialog-actions',
};
